import type { Router } from "vue-router";
import type { Store } from "vuex";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

type Customer = {
  allMsps?: boolean;
  allCustomers?: boolean;
  uuid?: string;
};

type SelectedAccount = {
  type_name?: string;
  name?: string;
  uuid?: string;
} | null;

type SelectCustomerHandlerDeps = {
  customer: Customer;
  selectedAccount: SelectedAccount;
  setCustomer: (customer: Customer) => void;
  router: Router;
  routePath: string;
  store: Store<unknown>;
};

export const selectCustomerHandler = async ({
  customer,
  selectedAccount,
  setCustomer,
  router,
  routePath,
  store,
}: SelectCustomerHandlerDeps) => {
  setCustomer(customer);

  const stateAuth =
    (
      store.state as {
        authentication?: {
          selectedAccount?: { uuid?: string };
          selectedMsp?: { uuid?: string };
        };
      }
    )?.authentication ?? {};
  const selectedUuid =
    selectedAccount?.uuid || stateAuth.selectedAccount?.uuid || null;
  const selectedMspUuid = stateAuth.selectedMsp?.uuid || null;

  if (customer.allMsps && selectedAccount?.type_name === "System") {
    try {
      await store.dispatch("authentication/setMspUser", null);
    } catch {
      // handled centrally via axios interceptors
    }

    store.dispatch("pageMeta/setMSP", "");
    await router
      .push(buildOrgUrl("system", selectedUuid, "dashboard"))
      .catch(() => {});
    return;
  }

  if (customer.allCustomers) {
    await router.push(buildOrgUrl("msp", selectedMspUuid, "customers"));
    return;
  }

  if (customer.allMsps && selectedAccount?.type_name === "MSP") {
    await router.push(buildOrgUrl("msp", selectedUuid, "customers"));
    return;
  }

  if (routePath !== "/customer/email_security/overview") {
    const targetUuid = customer.uuid || selectedUuid || undefined;
    await router.push(buildOrgUrl("customer", targetUuid, ""));
  }
};
